import { FC } from "react";
import { ScheduledTXDateProps } from "./types";
import { getDateTimeFormat } from "src/helpers/dateTime";

const ScheduledTXDate: FC<ScheduledTXDateProps> = ({ caseId, scheduled_tx_date }): JSX.Element => {
  return (
    <div className="card">
      <div className="card-header bg-success-subtle">
        <h4 className="mb-0 text-success">
          Case {caseId} Scheduled Tx Date
        </h4>
      </div>
      <div className="card-body">
        <div className="container-fluid case-notes-listing">
          {scheduled_tx_date && scheduled_tx_date.length > 0 && (
            scheduled_tx_date.map((item, index) => (
              <div className={`row mb-2 py-1 align-items-center ${index % 2 === 0 ? 'bg-secondary-subtle' : ''}`} key={index}>
                <div className="col-12 col-md-3">
                  <p className="mb-0 fs-6 text-start">{item && item.user ? item.user : "My QUTENZA Connect"}</p>
                </div>
                <div className="col-12 col-md-9">
                  <p className="mb-0 fs-6">{item ? item.description : ''}</p>
                </div>
                <div className="col-12 text-start pt-1">
                  <p className="mb-0 fs-6">{item ? getDateTimeFormat(item.time) : ''}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ScheduledTXDate;
